<template >
  <section class="body">
   
    <section class="w-full flex ">
      <h1 class="text-2xl relative bottom-14 font-semibold md:text-5xl lg:text-5xl text-white mx-auto top-20">
        Hi, I’m Parinistha Sharma
      </h1>
    </section>
  <section
    class="relative montserrat   md:bottom-24   bg-center h-[770px] flex flex-col md:flex-row justify-between items-center transition-opacity duration-500 ease-out overflow-hidden"
    :style="{ backgroundImage: 'url(./assets/hero-background.jpg)', opacity: sectionOpacity }"
  >
    <!-- Right Section -->
    <div v-if="isVisible" class="flex-1 mt-40  md:w-1/2 flex flex-col items-center ">
      <!-- First Image (smaller and rotated) -->
      <img
      loading="lazy"
        src="../assets/Subject.png"
        alt="Logo"
        class="w-10 pin-img h-8 relative left-14 top-10 z-20 sm:w-10 md:w-24 md:h-18 lg:w-11 lg:h-11 animate__animated animate__backInRight"
        :style="{ transform: 'rotate(15deg)' }"
      />
      <!-- Second Image (bigger and rotated) -->
     <!-- Second Image (bigger and rotated) -->
<div class="w-56  md:w-32 bg-transparent md:h-64 h-68 lg:w-80 lg:h-auto" :style="{ transform: 'rotate(15deg)' }">
  <img
  loading="lazy"
    class="animate__animated bg-transparent animate__slideInUp border-none relative w-[400px] md:w-32 md:h-64 h-72 lg:w-80 lg:h-auto mt-6"
 
    src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726624490/Frame_2_dmgdms.png"
    alt="Animated Logo"
  />
</div>

      <!-- Typing text at the end of the second image -->
      <div
        class="relative typing-text grayColor right-13 bottom-4 mb-2  animate__animated animate__pulse md:bottom-20 typewriter diffrent-color md:text-md lg:text-lg font-bold"
        :style="{ transform: 'rotate(15deg)' }"
      >
        {{ displayedText }}
      </div>
      <div
        class="relative typing-text grayColor right-13 bottom-2 md:bottom-20 animate__animated animate__pulse typewriter diffrent-color md:text-md lg:text-lg font-bold"
        :style="{ transform: 'rotate(15deg)' }"
      >
        {{ displayedText2 }}
      </div>
    </div>
      <!-- Left Section -->
    <div class="flex-1 top-20 mobile left-2 md:left-10 animate__animated animate__bounceInRight md:w-1/2 flex flex-col justify-center mt-16 p-4 md:p-6 ">
      
      <p class="text-lg md:text-xl mt-8 lg:text-3xl text-white pt-6 md:pt-16 lg:pt-6">
        A <span class="just-diffrent-color font-bold">Product Designer</span> who translates…
      </p>
      <div class="escape  text-lg mt-6 md:text-2xl lg:text-3xl text-white pt-16 md:pt-16 lg:pt-6">
  Numbers 
  <div>
    <span>  Into <span class="font-bold">Narratives</span></span>
  </div>
</div>
<div class="escape  text-lg  mt-6 md:text-xl lg:text-3xl text-white pt-6 md:pt-16 lg:pt-6">
  Insights 
  <div>
    <span > Into <span class="font-bold">Interfaces</span></span>
  </div>
</div>
      <!-- <p class="text-base pb-4  font-bold mt-14 md:text-2xl lg:text-2xl pt-2 md:pt-4 lg:pt-6 text-white">
        If data’s your muse, then I’m your digital storyteller
      </p> -->
    </div>
    

  </section>
  <section class="w-full flex -mt-24">
    <div class="mx-auto">
      <p class="mt-10 text-5xl dancing-script font-medium max-md:mt-6 max-md:text-2xl text-[#B1E5E5]">
        “I’m passionate  about enhancing digital experiences through data 
      </p>
      <p class="text-center mt-4 text-5xl dancing-script font-medium max-md:mt-6 max-md:text-2xl text-[#B1E5E5] ">
        driven insights that truly resonate with users”
      </p>
    </div>
    </section>
  <!-- <AboutSection/> -->
  <ButtonGroup/>

</section>
</template>

<script>
// import AboutSection from './AboutSection.vue'
import ButtonGroup from './WorkButtons.vue'

export default {
  name: "HeroSection",
  components: {
    // AboutSection,
    ButtonGroup,

  },
  
  data() {
    return {
      isVisible: true,
      displayedText: "3+ years of Experience",
      displayedText2: "Masters Graduate",
      sectionOpacity: 1, // Default opacity
    };
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = true;
    }, 1000); // Show after 1 second

    // Add scroll event listener
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Remove the scroll event listener
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollPosition = window.scrollY;
      const fadeStart = 200; // Start fading after 100px scroll
      const fadeEnd = 770; // Fully fade out by 400px scroll
      if (scrollPosition >= fadeStart && scrollPosition <= fadeEnd) {
        this.sectionOpacity = 1 - (scrollPosition - fadeStart) / (fadeEnd - fadeStart);
      } else if (scrollPosition > fadeEnd) {
        this.sectionOpacity = 0;
      } else {
        this.sectionOpacity = 1;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playwrite+CU:wght@100..400&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.montserrat {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
}
@keyframes typewriter {
  from {
    width: 0;
  }
  to {
    width: 40%;
  }
}

@keyframes blinkCursor {
  from {
    border-color: transparent;
  }
  to {
    border-color: black;
  }
}
@media (max-width:740px) {
  .typewriter{
    margin-bottom: 20px;
    height: auto;
  }
}
.typewriter {
  overflow: hidden;
  white-space: nowrap;
  animation: typewriter 4s steps(40) 1s 1 normal both,
    blinkCursor 500ms steps(40) infinite normal;
}

.diffrent-color {
  color: #A0E9E5 !important;
  /* font-family: "Playwrite CU", cursive; */
  font-optical-sizing: auto;
}
.just-diffrent-color{
  color: #A0E9E5 !important;
}
.escape {
  display: flex;
  flex-direction: row;
  gap: 0.5rem; /* Adjust gap as needed */
}

.escape div {
  display:inline-block;
  overflow:hidden;
  white-space:nowrap;
}

.escape div:first-of-type {   
  animation: showup 7s infinite;
}

.escape div:last-of-type {
  width:0px;
  animation: reveal 7s infinite;
}

.escape div:last-of-type span {
  margin-left:-355px;
  animation: slidein 7s infinite;
}

@keyframes showup {
    0% {opacity:0;}
    20% {opacity:1;}
    80% {opacity:1;}
    100% {opacity:0;}
}

@keyframes slidein {
    0% { margin-left:-800px; }
    20% { margin-left:-800px; }
    35% { margin-left:0px; }
    100% { margin-left:0px; }
}

@keyframes reveal {
    0% {opacity:0;width:0px;}
    20% {opacity:1;width:0px;}
    30% {width:355px;}
    80% {opacity:1;}
    100% {opacity:0;width:355px;}
}
.grayColor{
  color: #1D2D31 !important;
}
@media (max-width: 768px) {
  @keyframes typewriter {
  from {
    width: 0;
  }
  to {
    width: 71%;
  }
  
}
.mobile{
        display: block;
        height: 100%;
       
    }
    .typing-text{
    font-size: 14px !important;
    bottom: 60px;
    }
    .pin-img{
    left: 30px;
    width: 25px;
    height: 30px;
    top: 30px;
    }
    .hero-img{
      width: 358px !important;
      height: 200px;
    }
    
}
</style>
